import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
window.Alpine = Alpine;
Alpine.plugin(persist);

window.getDaysTillNextForceWipe = function () {
    const now = new Date();
    const currentYear = now.getUTCFullYear();
    const currentMonth = now.getUTCMonth();
    const firstThursday = new Date(Date.UTC(currentYear, currentMonth, 1));
    firstThursday.setUTCHours(19, 0, 0, 0);
    firstThursday.setUTCDate(
        firstThursday.getUTCDate() + ((4 - firstThursday.getUTCDay() + 7) % 7)
    );
    if (now > firstThursday) {
        firstThursday.setUTCMonth(currentMonth + 1);
        firstThursday.setUTCDate(1);
        firstThursday.setUTCHours(19, 0, 0, 0);
        firstThursday.setUTCDate(
            firstThursday.getUTCDate() +
                ((4 - firstThursday.getUTCDay() + 7) % 7)
        );
    }
    const timeDiff = firstThursday - now;
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};

window.calcStacks = function (form, maxDays, forceWipeDays, maxDaysForceWipe) {
    maxDays = maxDaysForceWipe ? forceWipeDays : maxDays;
    let data = {
        metal_refined: {
            amount: parseInt(form.hqmPerDay),
            stackSize: parseInt(form.hqmStackSize),
        },
        metal_fragments: {
            amount: parseInt(form.metalFragmentsPerDay),
            stackSize: parseInt(form.metalFragmentsStackSize),
        },
        stones: {
            amount: parseInt(form.stonesPerDay),
            stackSize: parseInt(form.stonesStackSize),
        },
        wood: {
            amount: parseInt(form.woodPerDay),
            stackSize: parseInt(form.woodStackSize),
        },
    };
    let bestDay = 0;
    const maxStacks = 6 * 4;
    for (let day = 0; day <= maxDays; day++) {
        let hqmStacks = Math.ceil(
            (data.metal_refined.amount * day) / data.metal_refined.stackSize
        );
        let metalFragmentsStacks = Math.ceil(
            (data.metal_fragments.amount * day) / data.metal_fragments.stackSize
        );
        let stonesStacks = Math.ceil(
            (data.stones.amount * day) / data.stones.stackSize
        );
        let woodStacks = Math.ceil(
            (data.wood.amount * day) / data.wood.stackSize
        );

        let totalStacks =
            hqmStacks + metalFragmentsStacks + stonesStacks + woodStacks;
        if (totalStacks > maxStacks) {
            break;
        }
        bestDay = day;
    }

    let stacks = [[], [], [], []];
    let n = 0;
    for (let type in data) {
        let amount = data[type].amount * bestDay;
        let stackSize = data[type].stackSize;
        while (amount > 0) {
            let stack = Math.min(amount, stackSize);
            let row = Math.floor(n / 6);

            n++;
            stacks[row].push({
                type: type,
                amount: stack,
                amountText: 'x' + stack,
                className: `item-${type}`,
            });
            amount -= stack;
        }
    }
    // Fill remaining slots with empty items
    while (n < 24) {
        let row = Math.floor(n / 6);
        stacks[row].push({
            type: 'empty',
            amount: 0,
            amountText: '',
            className: null,
        });
        n++;
    }

    let requestedDays = maxDays;
    let gotDays = bestDay;
    let text = '';
    if (requestedDays <= gotDays) {
        if (maxDaysForceWipe) {
            text = `That's enough till the next force wipe in ${forceWipeDays} days, all good!`;
        } else {
            text = `That's enough for ${gotDays} days, all good!`;
        }
    } else {
        text = `Your Cupboard can only hold enough resources for ${gotDays} days. `;
    }

    return {
        stacks,
        days: bestDay,
        text,
    };
};

Alpine.start();
